import {
	AMERICAN_MORTGAGE_INTEREST_RATE,
	AMERICAN_MORTGAGE_LIMITS,
} from "./CalculatorLimits";
import { getMaxLoanValue } from "./getMaxLoanValue";
import { getMonthlyInstalment } from "./getMonthlyInstalment";

type Params = {
	propertyPrice: number;
	loanValue: number;
	years: number;
	rounding: "floor" | "nearest";
};

export const getAmericanMortgagePlan = ({
	propertyPrice,
	loanValue,
	years,
	rounding,
}: Params) => {
	const hasValidPrice =
		propertyPrice >= AMERICAN_MORTGAGE_LIMITS.propertyPriceMin &&
		propertyPrice <= AMERICAN_MORTGAGE_LIMITS.propertyPriceMax;
	const maxLoanValue =
		propertyPrice >= 1
			? getMaxLoanValue({
					propertyPrice,
					ratio: AMERICAN_MORTGAGE_LIMITS.loanRatio,
					cap: AMERICAN_MORTGAGE_LIMITS.loanCap,
					step: AMERICAN_MORTGAGE_LIMITS.loanStep,
					rounding,
				})
			: AMERICAN_MORTGAGE_LIMITS.loanCap;
	const actualLoanValue = hasValidPrice ? Math.min(loanValue, maxLoanValue) : 0;

	return {
		hasValidPrice,
		maxLoanValue,
		actualLoanValue,
		monthlyPayment: getMonthlyInstalment(
			AMERICAN_MORTGAGE_INTEREST_RATE,
			years,
			actualLoanValue,
		),
	};
};
